
export default {
  name: 'Page404'
}
